import { Component, OnInit, signal, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { WalletComponent } from '@app/shared/components/wallet/wallet.component';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { Streak } from '@app/shared/models/user.model';
import { Wallet } from '@app/shared/models/wallet.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { StreakService } from '@app/shared/services/streak.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { WalletRepository } from '@app/shared/state/wallet/wallet.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { finalize } from 'rxjs';

@Component({
  selector: 'slotcom-keep-streak',
  templateUrl: './keep-streak.component.html',
  styleUrls: ['./keep-streak.component.scss'],
  standalone: true,
  imports: [ParagraphComponent, ButtonComponent, WalletComponent, SharedModule],
})
export class KeepStreakComponent implements OnInit {
  keepStreakModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private walletRepo = inject(WalletRepository);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private streakService = inject(StreakService);
  private userRepo = inject(UserRepository);
  private eventsRepo = inject(EventsRepository);

  event: LimitedTimeEvent;
  confirmationText: string;
  loading = signal(false);

  get wallet(): Wallet {
    return this.walletRepo.getWallet();
  }

  get streak(): Streak {
    return this.userRepo.getStreak();
  }

  ngOnInit(): void {
    this.event = this.eventsRepo.getEventById(this.keepStreakModalData.properties.eventId);
  }

  keepStreak() {
    if (this.walletRepo.getGems() < this.keepStreakModalData.properties.price) {
      this.closeModal(false);

      this.eventManager.openModal(new Modal(NonPersistedModalName.NotEnoughModalComponent, ModalType.View, this.event));
      return;
    }

    this.loading.set(true);

    this.streakService
      .restoreStreak()
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: () => this.closeModal(true),
        error: (err) => this.logger.error(err),
      });
  }

  openGemsShop(): void {
    this.closeModal(false);
    this.eventManager.openModal(
      new Modal(NonPersistedModalName.ShopModalComponent, ModalType.View, {
        tab: 'right',
      })
    );
  }

  closeModal(deleteModal: boolean) {
    this.eventManager.closeModal(
      new Modal(this.keepStreakModalData.id, ModalType.Persisted, this.keepStreakModalData, '', false, deleteModal)
    );
  }
}
